// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overview>*+*[data-v-26a86b76]{margin-top:24px}.overview .header[data-v-26a86b76]{display:flex;gap:12px;align-items:center}.overview .header__icon[data-v-26a86b76]{display:flex;align-items:center;justify-content:center;width:40px;height:40px;flex-shrink:0;border-radius:8px;background-color:#f7f7f8}.overview .header__icon img[data-v-26a86b76]{width:25px;height:25px}.overview section>*+*[data-v-26a86b76]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
